import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Axios from "../../services/AxiosInterceptor";

const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate();

  // Update form fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email || !formData.password) {
      alert("Please fill in all fields.");
      return;
    }

    if (!emailRegex.test(formData.email)) {
      alert("Invalid email format");
      return;
    }

    try {
      const data = await Axios.post("api/login", {
        email: formData.email,
        password: formData.password,
      });

      const result = data.data;
      console.log("result", result);

      if (result && result.token) {
        localStorage.setItem("token", result.token);
        localStorage.setItem("email", formData.email);
        localStorage.setItem("role", "vendor");
        navigate("/dashboard");
        window.location.reload();
      } else {
        alert("Login failed. Please try again.");
      }

      if (result?.status === "404") {
        alert("Kindly enter valid details");
      }
    } catch (error) {
      console.error("Login error", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    // <div className="flex items-center justify-center min-h-screen" style={{backgroundImage(URL:"")}}>
    <div
  className="flex items-center justify-center min-h-screen"
  style={{ backgroundImage: `url("/one.jpg")`, backgroundSize: "cover", backgroundPosition: "center" }}
>

      <div className="w-full max-w-md p-8 bg-transperent ">
        <h2 className="text-2xl
         font-bold text-center text-gray-800 mb-6">
          Login
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent"
              required
            />
          </div>
          <div className="mb-4">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter your password"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full py-2 text-white bg-yellow-500 rounded-lg hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-1"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
